var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { formatCurrency, getMoneyFormat } from '../helpers/currencies';
const getProductsByTag = (tag, isoCode, handle, sort_key, reverse) => __awaiter(void 0, void 0, void 0, function* () {
    const storeData = window.thGeolocationData.stores.find((store) => {
        return store.permanent_domain === window.Shopify.shop;
    });
    if (storeData) {
        const res = yield fetch(`https://${window.Shopify.shop}/api/2022-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storeData.s,
            },
            body: JSON.stringify({
                query: `
              query getProductByTag($tag: String, $country: CountryCode, $sort_key: ProductSortKeys, $reverse: Boolean) @inContext(country: $country){
                  products(first: 10, query: $tag, sortKey: $sort_key, reverse: $reverse) {
                  edges {
                      node {
                      id
                      handle
                      title
                      description
                      variants(first: 1) {
                          edges {
                              node {
                                priceV2 {
                                  amount
                                  currencyCode
                                }
                                compareAtPriceV2 {
                                    amount
                                    currencyCode
                                }
                              }
                          }
                      }
                      featuredImage {
                          url,
                          width,
                          height
                      }
                      metafield(namespace: "my_fields", key: "design_name") {
                          value
                      }
                      }
                  }
                  pageInfo {
                      hasNextPage
                  }
                  }
              }
              `,
                variables: {
                    country: isoCode,
                    tag: `tag:'${tag.replace(/'/gi, "\\'")}'`,
                    sort_key: sort_key,
                    reverse: reverse,
                },
            }),
        });
        const data = yield res.json();
        if (data.data.products.edges.length < 1)
            return;
        const filtered = data.data.products.edges.filter((product) => product.node.handle !== handle);
        if (filtered.length > 0) {
            return filtered;
        }
    }
    return null;
});
const getAvailableCurrencies = () => __awaiter(void 0, void 0, void 0, function* () {
    const storeData = window.thGeolocationData.stores.find((store) => {
        return store.permanent_domain === window.Shopify.shop;
    });
    if (storeData) {
        const res = yield fetch(`https://${window.Shopify.shop}/api/2022-07/graphql.json`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': storeData.s,
            },
            body: JSON.stringify({
                query: `
              query {
                localization {
                  availableCountries {
                    currency {
                      isoCode
                      name
                      symbol
                    }
                    isoCode
                    name
                    unitSystem
                  }
                  country {
                    currency {
                      isoCode
                      name
                      symbol
                    }
                    isoCode
                    name
                    unitSystem
                  }
                }
              }
              `,
            }),
        });
        const data = yield res.json();
        return data.data.localization;
    }
    return null;
});
const featuredProducts = () => __awaiter(void 0, void 0, void 0, function* () {
    const scriptTag = document.querySelector('#featured-products-state');
    const state = scriptTag ? JSON.parse(scriptTag.innerHTML) : null;
    if (!state)
        return;
    const products = yield getProductsByTag(state.tag, state.isoCode, state.handle, state.sort_key, state.reverse);
    const currencies = yield getAvailableCurrencies();
    const selectedCountry = currencies.availableCountries.filter((country) => country.isoCode === state.isoCode)[0];
    const featuredProducts = document.querySelector('[data-featured-products="featured_products"]');
    if (!products) {
        if (featuredProducts) {
            featuredProducts.remove();
        }
        return;
    }
    const featuredProductsContainer = document.querySelector('[data-featured-products-list]');
    const itemsContainer = featuredProductsContainer.querySelector('[data-featured-products-items]');
    const quickViewText = featuredProductsContainer.dataset.quickView;
    const buttonsContainer = featuredProductsContainer.querySelector('[data-featured-products-buttons]');
    let largestApsectRatio = 0;
    products.forEach(({ node }, i) => {
        const id = `featured-product-item_${i + 1}`;
        const productItem = document.createElement('product-item');
        productItem.classList.add('product-item');
        productItem.setAttribute('id', id);
        productItem.innerHTML = `<div class="product-item__image-wrapper"></div>
                <div class="product-item__info">
                  <div class="product-item-meta">
                    <a href="/" class="product-item-meta__title"></a>
                    <div class="product-item-meta__price-list-container">
                      <div class="price-list price-list--centered">
                        <span class="price"></span>
                      </div>
                    </div>
                    <div class="product-item__cta-wrapper">
                      <button type="button" is="toggle-button" aria-controls="${`featured-product-item_${i + 1}`}-drawer" aria-expanded="false" class="product-item__link link text--subdued hidden-phone" data-inner-text></button>
                      <button type="button" is="toggle-button" aria-controls="${`featured-product-item_${i + 1}`}-popover" aria-expanded="false" class="product-item__link link text--subdued hidden-tablet-and-up" data-inner-text></button>
                      <quick-buy-drawer id="${`featured-product-item_${i + 1}`}-drawer" href="/" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>
                      <quick-buy-popover id="${`featured-product-item_${i + 1}`}-popover" href="/" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>
                    </div>
                  </div>
                </div>`;
        const imageWrapper = productItem.querySelector('.product-item__image-wrapper');
        const title = productItem.querySelector('.product-item-meta__title');
        const price = productItem.querySelector('.price');
        const buttons = productItem.querySelectorAll('button[data-inner-text]');
        const quickBuyDrawer = productItem.querySelector('quick-buy-drawer');
        const quickBuyPopover = productItem.querySelector('quick-buy-popover');
        const moneyFormat = getMoneyFormat(selectedCountry);
        const money = formatCurrency(node.variants.edges[0].node.priceV2.amount * 100, moneyFormat);
        const imageAnchor = document.createElement('a');
        imageAnchor.setAttribute('href', `/products/${node.handle}`);
        const image = document.createElement('img');
        image.setAttribute('src', node.featuredImage.url);
        image.setAttribute('class', 'product-item__primary-image');
        image.setAttribute('width', node.featuredImage.width);
        image.setAttribute('height', node.featuredImage.height);
        imageAnchor.appendChild(image);
        imageWrapper.appendChild(imageAnchor);
        const aspectRatio = node.featuredImage.width / node.featuredImage.height;
        if (aspectRatio > largestApsectRatio) {
            largestApsectRatio = aspectRatio;
        }
        title.setAttribute('href', `/products/${node.handle}`);
        title.innerText = node.title;
        price.innerText = `${money}`;
        buttons.forEach((button) => {
            button.innerText = quickViewText;
        });
        quickBuyDrawer.setAttribute('href', `/products/${node.handle}?view=quick-buy-drawer`);
        quickBuyPopover.setAttribute('href', `/products/${node.handle}?view=quick-buy-popover`);
        itemsContainer.appendChild(productItem);
    });
    buttonsContainer === null || buttonsContainer === void 0 ? void 0 : buttonsContainer.style.setProperty('--smallest-image-aspect-ratio', `${largestApsectRatio}`);
});
featuredProducts();
